// extracted by mini-css-extract-plugin
export default {"show":"menuitems_show__RKEHb","hide":"menuitems_hide__OS8An","item":"menuitems_item__Qqzo4"};